import "./stylesheets/app.scss";
import React, {Component} from "react";
import {BrowserRouter as Router} from "react-router-dom";
import Loadable from "react-loadable";
import Preloader from "./components/Preloader";

const DefaultLayout = Loadable({
  loading: Preloader,
  loader: () => import("./containers/DefaultLayout"),
});

class App extends Component {
  render() {
    return (
      <Router>
        <DefaultLayout/>
      </Router>
    );
  }
}

export default App;
